import axios_ from "../utils/axios";

export default {
  /**
   * 知识库信息列表
   */
  getLibrarys(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/informationStorage/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库信息下拉列表
   */
  getSelectLibrarys(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/informationStorage/selectLists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 新增编辑
   */
  storeLibrary(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/informationStorage/${param.id ? "uptStore" : "store"}`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 是否启用
   */
  storeLibraryEnable(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/informationStorage/enableInformationStorage`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 删除
   */
  delLibrary(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/informationStorage/del`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 详情
   */
  getLibraryDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/informationStorage/detail`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 分类列表
   */
  getClassifiesByLib(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/informationClassify/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 分类新增、编辑
   */
  classifyStore(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/informationClassify/${param.id ? "uptStore" : "store"}`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 分类 删除
   */
  delClassify(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/informationClassify/del`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 内容列表
   */
  getContents(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/information/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 内容新增、编辑
   */
  contentStore(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/${param.id ? "uptStore" : "store"}`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 内容 详情
   */
  getContentDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/information/detail`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 内容删除
   */
  delContent(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/del`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 上传资料
   */
  contentUploadStore(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/uploadStore`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 开始抓取接口
   */
  grabLinkStart(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/linkStoreStart`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库 抓取链接
   */
  grabLinksStore(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/linkStore`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 知识库停止训练
   */
  stopTraining(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/stopTraining`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 从知识库 选择资料
   */
  storeContentFromStorage(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/information/option`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
};
